import { useMemo } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

const DEF_PARAM_NAME = 'fp';
const useSwitchPanel = (paramName = DEF_PARAM_NAME, def: boolean = false) => {
  const [searchParams, setSearchParam] = useSearchParams();

  const show = useMemo(() => {
    const ret =
      searchParams.get(paramName) === null
        ? def
        : searchParams.get(paramName) === '1';
    return ret;
  }, [searchParams, paramName, def]);

  const setShow = useMemo(() => {
    return (value: boolean) => {
      searchParams.set(paramName, value === true ? '1' : '0');
      setSearchParam(searchParams, { replace: true });
    };
  }, [setSearchParam, paramName, searchParams]);

  return { show, setShow };
};

export const useSwitchPar = (paramName: string, def: string) => {
  const [searchParams, setSearchParam] = useSearchParams();

  const show = useMemo(() => {
    const ret = searchParams.get(paramName);
    return ret === null ? def : ret;
  }, [searchParams, paramName, def]);

  const setShow = useMemo(() => {
    return (value: string) => {
      searchParams.set(paramName, value);
      setSearchParam(searchParams, { replace: true });
    };
  }, [setSearchParam, paramName, searchParams]);

  return { show, setShow };
};

export const useSwitchShowDetails = (
  paramName = 'd',
  def: boolean,
  customRoute?: string,
) => {
  const { search, pathname } = useLocation();
  const [searchParams, setSearchParam] = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();

  const show = useMemo(() => {
    const ret = params[paramName] === null ? def : params[paramName] === 'd';
    return ret;
  }, [params, paramName, def]);

  const setShow = useMemo(() => {
    return (value: boolean) => {
      if (value) {
        const targetRoute = customRoute ? customRoute : '/t/r/d';
        navigate(`${targetRoute}${search}`, { replace: false });

        // Hide navigation when drill through
        searchParams.set('nav', '0');
        // Set return back pathname
        if (pathname) searchParams.set('ret', pathname);
      } else {
        navigate(`/t/r${search}`);
        searchParams.set('ret', '');
      }
      setSearchParam(searchParams, { replace: true });
    };
  }, [customRoute, navigate, pathname, search, searchParams, setSearchParam]);

  return { show, setShow };
};
export default useSwitchPanel;
